// extracted by mini-css-extract-plugin
export var backupIcon = "_or-1";
export var image = "_or-0";